import axios from "axios";
import { useState } from "react";
import { BASE_URL } from '../config';

const TransactionAdd = ({ onTransactionAdded }) => {
  const [amount, setAmount] = useState("");
  const [type, setType] = useState("expense"); // default expense
  const [category, setCategory] = useState("");
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/transactions`,
        {
          amount: amount,
          type: type,
          category: category,
          date: date,
          note: note,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Transaction added successfully!");
      // Clear form
      setAmount("");
      setType("expense");
      setCategory("");
      setDate("");
      setNote("");
      setErrors({});

      if (onTransactionAdded) onTransactionAdded(); // notify parent to reload
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
      } else if (error.response?.status === 401) {
        alert("Unauthorized. Please login again.");
      } else {
        alert("Something went wrong!");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">Amount</label>
        <div className="col-lg-9">
          <input
            type="number"
            step="0.01"
            name="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className={`form-control ${errors.amount ? "is-invalid" : ""}`}
          />
          {errors.amount && (
            <div className="invalid-feedback">{errors.amount[0]}</div>
          )}
        </div>
      </div>

      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">Type</label>
        <div className="col-lg-9">
          <select
            name="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            className={`form-control ${errors.type ? "is-invalid" : ""}`}
          >
            <option value="income">Income</option>
            <option value="expense">Expense</option>
          </select>
          {errors.type && (
            <div className="invalid-feedback">{errors.type[0]}</div>
          )}
        </div>
      </div>

      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">Category</label>
        <div className="col-lg-9">
          <input
            type="text"
            name="category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className={`form-control ${errors.category ? "is-invalid" : ""}`}
          />
          {errors.category && (
            <div className="invalid-feedback">{errors.category[0]}</div>
          )}
        </div>
      </div>

      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">Date</label>
        <div className="col-lg-9">
          <input
            type="date"
            name="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className={`form-control ${errors.date ? "is-invalid" : ""}`}
          />
          {errors.date && (
            <div className="invalid-feedback">{errors.date[0]}</div>
          )}
        </div>
      </div>

      <div className="form-group row mb-2">
        <label className="col-lg-3 col-form-label text-lg-end">Note</label>
        <div className="col-lg-9">
          <textarea
            name="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className={`form-control ${errors.note ? "is-invalid" : ""}`}
          />
          {errors.note && (
            <div className="invalid-feedback">{errors.note[0]}</div>
          )}
        </div>
      </div>

      <div className="text-center p-2 m-2">
        <button type="submit" className="btn btn-primary">
          <i className="fas fa-check"></i> Submit
        </button>
      </div>
    </form>
  );
};

export default TransactionAdd;
